/*
 * Sprachhinweis — entscheidet nur, OB der Balken erscheint.
 *
 * Die Umschaltung selbst laeuft ueber ein echtes Formular im Snippet und
 * braucht dieses Skript nicht. Faellt JS aus, erscheint schlicht kein Hinweis
 * — niemand wird ausgesperrt.
 *
 * Es wird NIE umgeleitet. Nur angeboten.
 */
(function () {
  'use strict';

  var MERKER = 'rxk-locale-hint-dismissed';

  var box = document.querySelector('[data-rxk-hint]');
  if (!box) return;

  /*
   * Wer den Hinweis einmal weggeklickt hat, bekommt ihn nicht wieder.
   * localStorage kann in privaten Fenstern oder bei gesperrten Cookies
   * werfen — dann lieber gar keinen Hinweis als einen Skriptfehler.
   */
  try {
    if (window.localStorage.getItem(MERKER)) return;
  } catch (e) {
    return;
  }

  var aktuell = (box.dataset.rxkHintCurrent || '').toLowerCase();

  // "de=Deutsch|en=English|fr=Français|" -> Liste
  var angebot = (box.dataset.rxkHintLanguages || '')
    .split('|')
    .filter(Boolean)
    .map(function (paar) {
      var i = paar.indexOf('=');
      return { iso: paar.slice(0, i).toLowerCase(), name: paar.slice(i + 1) };
    });
  if (!angebot.length) return;

  /*
   * navigator.languages ist nach Vorliebe sortiert — der erste Treffer ist
   * also die beste verfuegbare Sprache, nicht irgendeine. Regionalcodes
   * werden gekuerzt: "de-AT" und "de-CH" sind beide Deutsch.
   */
  var wunsch = (navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language || ''];

  var treffer = null;
  for (var i = 0; i < wunsch.length && !treffer; i++) {
    var kurz = String(wunsch[i]).slice(0, 2).toLowerCase();
    if (!kurz) continue;

    // Spricht der Besucher bereits die aktuelle Sprache, ist nichts zu tun.
    if (kurz === aktuell.slice(0, 2)) return;

    for (var j = 0; j < angebot.length; j++) {
      if (angebot[j].iso.slice(0, 2) === kurz) {
        treffer = angebot[j];
        break;
      }
    }
  }
  if (!treffer) return;

  var textEl = box.querySelector('[data-rxk-hint-text]');
  var i18nEl = box.querySelector('[data-rxk-hint-i18n]');
  var eingabe = box.querySelector('[data-rxk-hint-input]');
  if (!textEl || !i18nEl || !eingabe) return;

  var i18n;
  try {
    i18n = JSON.parse(i18nEl.textContent);
  } catch (e) {
    return;
  }

  textEl.textContent = String(i18n.text || '').replace('%{language}', treffer.name);
  eingabe.value = treffer.iso;

  /*
   * lang am Balken setzen: Der Satz nennt die fremde Sprache, steht aber in
   * der aktuellen. Vorlesegeraete sollen ihn in der aktuellen Sprache lesen —
   * deshalb bleibt es beim Seiten-lang, nur der Sprachname selbst wird
   * ausgezeichnet.
   */
  box.hidden = false;

  var schliessen = box.querySelector('[data-rxk-hint-close]');
  if (schliessen) {
    schliessen.addEventListener('click', function () {
      box.hidden = true;
      try {
        window.localStorage.setItem(MERKER, '1');
      } catch (e) {
        /* Nicht schlimm — dann erscheint er beim naechsten Besuch erneut. */
      }
    });
  }

  /*
   * Beim Wechseln ebenfalls merken. Sonst begruesst der Balken den Kunden
   * nach dem Neuladen erneut, weil seine Browsersprache ja weiterhin von der
   * Seitensprache abweichen KANN — etwa wenn er auf Englisch wechselt,
   * waehrend Deutsch ganz oben in seiner Liste steht.
   */
  var annehmen = box.querySelector('[data-rxk-hint-accept]');
  if (annehmen) {
    annehmen.addEventListener('click', function () {
      try {
        window.localStorage.setItem(MERKER, '1');
      } catch (e) {
        /* egal */
      }
    });
  }
})();
